__turbopack_context__.v({
  "aiTranslationDisclaimer": "style-module-scss-module__Kmv3OG__aiTranslationDisclaimer",
  "component": "style-module-scss-module__Kmv3OG__component",
  "fields": "style-module-scss-module__Kmv3OG__fields",
  "heading": "style-module-scss-module__Kmv3OG__heading",
  "section": "style-module-scss-module__Kmv3OG__section",
});
